import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import './VideoModal.css';
import { IoClose } from 'react-icons/io5';
import { BsYoutube } from 'react-icons/bs';
import { parseVideoTitle, getDivisionClass } from '../videoMatching';

const STATUS_LABELS = {
    live: 'En direct',
    upcoming: 'À venir',
    replay: 'Replay',
};

// Grande modale avec le lecteur YouTube intégré (comme sur la page Live vidéo).
// video : { videoId, status, url, title } (cf. findMatchVideo)
// Rendue dans <body> (portal) pour passer au-dessus du menu et des cartes.
function VideoModal({ video, onClose }) {
    const closeRef = useRef(null);

    useEffect(() => {
        const handleKey = (e) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleKey);
        // pas de défilement de la page derrière la modale
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        closeRef.current?.focus();
        return () => {
            document.removeEventListener('keydown', handleKey);
            document.body.style.overflow = previousOverflow;
        };
    }, [onClose]);

    const { division, journee, match, teams } = parseVideoTitle(video.title);

    return createPortal(
        // stopPropagation : les événements d'un portal remontent quand même l'arbre React
        // (sinon un clic ici déplierait la rencontre ou suivrait le lien de la carte parente)
        <div className="video_modal_overlay" onClick={(e) => { e.stopPropagation(); onClose(); }}>
            <div
                className="video_modal"
                role="dialog"
                aria-modal="true"
                aria-label={video.title}
                onClick={(e) => e.stopPropagation()}
            >
                <header className="video_modal_header">
                    <div className="video_modal_tags">
                        <span className={"video_modal_status " + video.status}>
                            {video.status === 'live' && <span className="video_modal_dot" aria-hidden="true" />}
                            {STATUS_LABELS[video.status]}
                        </span>
                        {
                            division &&
                            <span className={"video_modal_division " + getDivisionClass(division)}>{division}</span>
                        }
                        {
                            journee &&
                            <span className="video_modal_journee">{journee}</span>
                        }
                    </div>
                    <button ref={closeRef} type="button" className="video_modal_close" onClick={onClose} aria-label="Fermer">
                        <IoClose />
                    </button>
                </header>

                <div className="video_modal_player">
                    <iframe
                        src={`https://www.youtube.com/embed/${video.videoId}?autoplay=1&rel=0`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title={video.title}
                    />
                </div>

                <footer className="video_modal_footer">
                    <h2 className="video_modal_title">
                        {
                            teams ?
                            <>
                                {teams[0]} <span className="video_modal_vs">vs</span> {teams[1]}
                            </>
                            :
                            match
                        }
                    </h2>
                    <a className="video_modal_youtube" href={video.url} target="_blank" rel="noreferrer">
                        <BsYoutube /> Ouvrir sur YouTube
                    </a>
                </footer>
            </div>
        </div>,
        document.body
    );
}

export default VideoModal;
